// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__WZ_tv","loaderOuter":"PageOverlayLoader_loaderOuter__cagGv"};